import { Skeleton } from '@/components/ui/skeleton'
import { PresumedUnavailableBrowser } from '@/components/instructor/PresumedUnavailableBrowser'
import { PageHero } from '@/components/dashboard/fx/PageHero'
import { NameMarquee } from '@/components/dashboard/fx/NameMarquee'
import { PAGE_WIDTH } from '@/components/dashboard/fx/layout'
import { useUnlicensedArtists } from '@/hooks/useUnlicensedArtists'

export function UnlicensedArtistsPage() {
  const { data, error } = useUnlicensedArtists()

  return (
    <div className="overflow-x-clip">
      <PageHero
        eyebrow="Licensing gaps"
        title="Presumed"
        accent="unavailable."
        description="Artists the wider Last.fm community ranks highly across several of our themes, yet who never show up anywhere in the catalog. Absence alone doesn't prove why -- it could be a licensing gap, a stylistic mismatch, or a name we haven't matched correctly -- but showing up across multiple different themes is a strong signal something specific is going on. We assume it's licensing until shown otherwise, and omit these from theme recommendations rather than suggest a track that likely can't be added anyway."
      >
        {data && data.length > 0 && (
          <div className="pb-8">
            <NameMarquee compact duration={90} words={data.slice(0, 24).map((a) => a.name)} />
          </div>
        )}
      </PageHero>

      <div className={`${PAGE_WIDTH} py-12`}>
        {error && <p className="text-sm text-destructive">Couldn&apos;t load this list: {error}</p>}

        {data ? (
          data.length > 0 ? (
            <PresumedUnavailableBrowser artists={data} />
          ) : (
            <p className="text-muted-foreground">
              No presumed-unavailable artists detected yet -- nothing rises above the significance threshold.
            </p>
          )
        ) : (
          <div className="flex flex-col gap-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} className="h-24 w-full rounded-2xl" />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
